import o from "./closeIndex.ce.vue.js";
import { defineAndRegisterElement as e } from "../../utils/register-element.js";
const t = e(o);
export {
  t as initCloseForm
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/close-form/index.js
// module id = 1232
// module chunks = 67